<template>
  <div class="app-form-field" :class="className">
    <label v-if="label" class="app-form-field__label" :class="labelClassName">
      {{ label }}<span v-if="required" class="app-form-field__required">*</span>
    </label>
    <p v-if="topDescription" class="app-form-field__top-description">
      {{ topDescription }}
    </p>
    <div class="app-form-field__control">
      <slot />
    </div>
    <p v-if="description" class="app-form-field__description">
      {{ description }}
    </p>
    <p v-if="errorMessage" class="app-form-field__error">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'AppFormField',
  props: {
    label: { type: String, default: '' },
    description: { type: String, default: '' },
    topDescription: { type: String, default: '' },
    errorMessage: { type: String, default: '' },
    required: { type: Boolean, default: false },
    className: { type: String, default: '' },
    labelClassName: { type: String, default: '' },
  },
};
</script>
